"use client";

import FlagIcon from "@app/_icons/FlagIcon/FlagIcon";
import { Button } from "@ui/button";
import { Loader2 } from "lucide-react";
import type { ComponentProps, MouseEvent } from "react";
import useDeleteWishlistItem from "../../hooks/useDeleteWishlistItem";
import useDeleteWishlistItemTag from "../../hooks/useDeleteWishlistItemTag";
import { WishlistProduct } from "../../utils/sortWishlistItems";

export default function WishlistItemToggle({
  item,
  tagId,
  ...props
}: { item: WishlistProduct; tagId?: number } & ComponentProps<typeof Button>) {
  const { deleteWishlistItemAsync, isPending: isDeletingItem } =
    useDeleteWishlistItem();
  const { deleteWishlistItemTagAsync, isPending: isDeletingTag } =
    useDeleteWishlistItemTag();
  const isPending = isDeletingItem || isDeletingTag;

  async function onClick(event: MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    event.preventDefault();

    if (tagId && item.wishlistItem.id) {
      await deleteWishlistItemTagAsync({
        tagId,
        wishlistItemId: item.wishlistItem.id,
      });
      return;
    }

    await deleteWishlistItemAsync(item.wishlistItem);
  }

  return (
    <Button onClick={onClick} variant="ghost" size="icon" {...props}>
      {isPending ? (
        <Loader2 className="size-4 animate-spin" strokeWidth={2} />
      ) : (
        <FlagIcon className="size-4 fill-black" />
      )}
    </Button>
  );
}
